<template>
  <div class="filters-show-scroll auto">
    <div class="boxsizing filters-show-wrap" v-for="(item, index) in showVal" :key="index" :style="index === 0 ? 'position:relative;z-index:9;' : ''">
      <div class="first-group">
        <div class="first-is-empty" v-if="index === 0">
          <div class="first-line auto"></div>
          <div class="first-btn" v-if="showVal.length > 1 || disabled">
            <switch-box v-model="defaultFirst" :options="firstOptions" :disableChoose="true"></switch-box>
          </div>
          <el-button icon="el-icon-plus" circle size="small" class="first-btn" v-else @click="addFirst"></el-button>
        </div>
        <div class="first-is-empty" v-else>
          <div class="first-line first-line2 auto"></div>
        </div>
      </div>
      <div class="first-group first-group2" v-show="item['segments'].length > 1">
        <div class="first-is-empty">
          <div class="first-group2-box" :style="'height:' + 100 / item['segments'].length * (item['segments'].length - 1) + '%;top:' + 100 / item['segments'].length / 2 + '%;'">
            <div class="first-group2-line first-group2-line1 auto"></div>
            <div class="first-group2-line first-group2-line2 auto"></div>
            <div class="first-group2-linex auto">
              <div v-for="(line, lineIndex) in (item['segments'].length - 1)" :key="lineIndex"></div>
            </div>
            <div class="first-group2-line-radius auto">
              <div class="first-group2-line-radius1"><div></div></div>
              <div class="first-group2-line-radius2"><div></div></div>
            </div>
          </div>
          <div class="first-btn first-group2-btn" v-if="index === 0">
            <switch-box v-model="showVal[index]['jbc']" :disableChoose="!!disabled"></switch-box>
          </div>
          <div class="first-btn first-group2-btn" v-else>
            <switch-box v-model="showVal[index]['jbc']" :options="firstOptions" :disableChoose="true"></switch-box>
          </div>
        </div>
      </div>
      <div class="draggable-content">
        <div v-for="(item2, index2) in item['segments']" :key="index2" class="draggable-box">
          <div class="draggable-switch-box">
            <switch-box v-model="showVal[index]['segments'][index2]['jbc']" :disableChoose="!!disabled"></switch-box>
          </div>
          <div class="draggable-delete-box" v-if="!disabled && (item['segments'].length > 1 || index > 0)">
            <el-button icon="el-icon-delete" circle size="small" @click="deleteGroup(index, index2)"></el-button>
          </div>
          <draggable :list="item['segments'][index2]['segments']" group="item" style="width:100%;min-width:800px;min-height:200px;border:1px solid #ddd;box-sizing: border-box;overflow:hidden;padding: 10px 20px 20px 0;" :disabled="!!disabled" :sort="true" @change="log" @add="onAdded(index, index2)">
            <div class="tag-group-item auto boxsizing" v-for="(item3, index3) in item['segments'][index2]['segments']" :key="index3">
              <span @click="deleteItem(index, index2, index3)" class="delete-icon auto" v-if="!disabled"></span>
              <div class="item-title auto ellipsis" :title="item3.title"><i></i>{{item3.title}}</div>
              <div class="item-child-list auto ellipsis boxsizing" :title="item3.desc">{{item3.desc}}</div>
              <div class="item-text auto ellipsis" v-if="item3.value.defaultTagTypeView === 'dateRange'" :title="item3.value.values[0] + '至' + item3.value.values[1]">
                {{item3.value.values[0]}} 至 {{item3.value.values[1]}}
              </div>
              <div class="item-text auto" v-else-if="item3.value.tagTypeView === 'range'">
                &gt;={{item3.value.values[0]}}，&lt;={{item3.value.values[1]}}
              </div>
              <div class="item-text auto" v-else-if="item3.value.tagTypeView === 'string'">
                {{Array.isArray(item3.value.values) ? item3.value.values.join('/') : item3.value.values}}
              </div>
              <div class="item-text auto" v-else>{{item3.name}}</div>
              <div class="item-bot auto">标签受众源</div>
            </div>
          </draggable>
        </div>
        <div class="group-plus-btn auto" v-if="!disabled">
          <el-button icon="el-icon-plus" circle size="small" @click="addGroup(index)"></el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  name: 'JdFiltersShow',
  props: [
    'value',
    'disabled'
  ],
  data () {
    return {
      defaultFirst: 'must_not',
      firstOptions: [
        {
          value: 'must_not',
          name: '差'
        }
      ],
      showVal: [
        {
          jbc: 'must',
          segments: [
            {
              group: '',
              jbc: 'must',
              segments: [
              ]
            }
          ]
        }
      ],
      addVal: ''
    }
  },
  watch: {
    'value': function (val) {
      if (val) {
        this.showVal = val
      }
    },
    'showVal': {
      handler: function (val) {
        this.$emit('input', val)
      },
      deep: true
    }
  },
  components: {
    draggable
  },
  methods: {
    addFirst () {
      this.showVal.push({
        jbc: 'must_not',
        segments: [
          {
            group: '',
            jbc: 'must',
            segments: [
            ]
          }
        ]
      })
    },
    addGroup (index) {
      this.showVal[index]['segments'].push({
        group: '',
        jbc: 'must',
        segments: [
        ]
      })
    },
    deleteGroup (index, index2) {
      this.showVal[index]['segments'].splice(index2, 1)
      if (index > 0 && this.showVal[index]['segments'].length < 1) {
        this.showVal.splice(1, 1)
      }
    },
    deleteItem (index, index2, index3) {
      this.showVal[index]['segments'][index2]['segments'].splice(index3, 1)
      if (this.showVal[index]['segments'][index2]['segments'].length < 1) {
        this.showVal[index]['segments'][index2]['group'] = ''
      }
    },
    onAdded (index, index2) {
      // console.log('onAdded', this.showVal[index]['segments'][index2]['segments'])
      if (this.showVal[index]['segments'][index2]['segments'].length === 1) {
        this.showVal[index]['segments'][index2]['group'] = this.addVal['element']['group']
      }
      if (this.showVal[index]['segments'][index2]['group'] !== '' && this.addVal['element']['group'] !== this.showVal[index]['segments'][index2]['group']) {
        this.showVal[index]['segments'][index2]['segments'].splice(this.addVal['newIndex'], 1)
        this.$message.error('只能移动同一组标签！')
        return false
      }
      if (this.showVal[index]['segments'][index2]['segments'].length > 1) {
        let item = this.showVal[index]['segments'][index2]['segments'][this.addVal['newIndex'] === 0 ? 1 : 0]
        if (item['value']['tagTypeView'] === 'range' && !item['value']['defaultTagTypeView']) {
          if (this.addVal['element']['title'] !== item['title']) {
            this.showVal[index]['segments'][index2]['segments'].splice(this.addVal['newIndex'], 1)
            this.$message.error('一个Group下只能有一种区间条件！')
            return false
          }
        }
      }
      let length = 0
      this.showVal[index]['segments'][index2]['segments'].map(item => {
        if (item['value']['values'] === this.addVal['element']['value']['values'] && item['desc'] === this.addVal['element']['desc'] && item['title'] === this.addVal['element']['title']) {
          length++
        }
      })
      if (length > 1) {
        this.showVal[index]['segments'][index2]['segments'].splice(this.addVal['newIndex'], 1)
      }
    },
    log (e) {
      if (e['added']) {
        this.addVal = e['added']
        // console.log('log', e['added'])
      }
    }
  },
  mounted () {
    if (this.value) {
      this.showVal = this.value
    }
  },
  created () {
  }
}
</script>

<style scoped>
.filters-show-scroll {
  width: 100%;
  height: calc(100vh - 330px);
  padding-bottom: 20px;
  overflow: auto;
}
.filters-show-wrap {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.first-group, .first-is-empty {
  display: flex;
  align-items: stretch;
  position: relative;
}
.first-is-empty {
  min-width: 70px;
}
.first-group2 .first-is-empty {
  min-width: 150px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  position: relative;
}
.first-btn {
  position: absolute;
  bottom: -16px;
  left: 50%;
  margin-left: -16px;
}
.first-group2-btn {
  margin-left: 0;
  bottom: 50%;
  margin-bottom: -16px;
  left: 0;
}
.first-line {
  position: absolute;
  width: 50%;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  left: 50%;
  border-radius: 20px 0 0 0;
  height: 50%;
  bottom: 0;
}
.first-line2 {
  bottom: 50%;
  border: none;
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-radius: 0 0 0 20px;
}
.first-group2-box {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.first-group2-line {
  width: 50%;
  height: 50%;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  position: absolute;
  border-radius: 0 0 10px 0;
}
.first-group2-line2 {
  top: 50%;
  border: none;
  border-right: 1px solid #ddd;
  border-top: 1px solid #ddd;
  border-radius: 0 10px 0 0;
}
.first-group2-linex {
  width: 50%;
  position: absolute;
  height: 100%;
  left: 50%;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: column;
}
.first-group2-linex div {
  border-top: 1px solid #ddd;
  flex:1;
}
.first-group2-linex div:last-child {
  border-bottom: 1px solid #ddd;
}
.first-group2-line-radius {
  width: 10px;
  height: 100%;
  position: absolute;
  left: 50%;
}
.first-group2-line-radius1 {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
}
.first-group2-line-radius1 div {
  width: 9px;
  height: 9px;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  border-radius: 10px 0 0 0;
}
.first-group2-line-radius2 {
  width: 10px;
  height: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
}
.first-group2-line-radius2 div {
  width: 9px;
  height: 9px;
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-radius: 0 0 0 10px;
}

.draggable-content {
  flex: 1;
}
.draggable-box {
  width: 100%;
  position: relative;
  padding-top: 30px;
}
.draggable-switch-box {
  position: absolute;
  left: 30px;
  top: 14px;
  z-index: 999;
}
.draggable-delete-box {
  position: absolute;
  left: 80px;
  top: 15px;
}
.tag-group-group {
  padding: 10px 10px 0;
  border-radius: 5px;
  background: #e4e4e4;
  cursor: pointer;
  -webkit-transition: all .8s;
  transition: all .8s;
  margin-top: 10px;
}
.tag-group-group:hover {
  background: #5AA7F7;
}
.tag-group-item {
  box-shadow: 0 1px 2px 0 rgba(23,35,61,.25);
  -webkit-box-shadow: 0 1px 2px 0 rgba(23,35,61,.25);
  border-radius: 4px 4px 10px 10px;
  background: #fff;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
  padding-top: 10px;
  width: 260px;
  float: left;
  margin: 20px 0 0 20px;
}
.item-title {
  position: relative;
  padding-left: 10px;
  margin: 0 20px 0 10px;
  line-height: 16px;
}
.item-title i {
  display: block;
  width: 2px;
  height: 15px;
  background-image: linear-gradient(-135deg,#7061ef,#4d77f4);
  left: 0;
  top: 0;
  overflow: hidden;
  position: absolute;
}
.item-text {
  font-size: 14px;
  color: #333;
  padding: 5px 20px 0 20px;
}
.item-bot{
  height: 30px;
  line-height: 30px;
  text-indent: 20px;
  background: #f7f5f6;
  margin-top: 15px;
}
.item-child-list {
  width: 100%;
  height: 24px;
  line-height: 24px;
  padding: 0 20px 0 20px;
  margin-top: 10px;
}
.delete-icon {
  position: absolute;
  right: 10px;
  top: 5px;
}
.delete-icon::before {
  content: "x";
}
.group-plus-btn {
  margin-top: 20px;
}
</style>
